
export default function DropDownColumnValidator(values) {
  const options = values.options.options;
  
  // Check if options is falsy or empty
  if (!options || options.length === 0) {
    window.appStore.notificationStore.showNotification(
      `Please add dropdown options`,
      "error"
    );
    return false;
  }

  const emptyOptions = options.filter((value) => value.trim() === "");

  if (emptyOptions.length > 0) {
    const errorMessage = `${values.column_name} does not allow empty options`;

    window.appStore.notificationStore.showNotification(errorMessage, "error");
    return false;
  }

  return true;
}

